import styled from "styled-components";
import Title from "../../../common/Title";
import Division from "../../../common/Division";
import SkillBox from "../../../common/SkillBox";
import ec2 from "../../../../assets/img/new/aws-ec2.svg";
import s3 from "../../../../assets/img/new/aws-s3.svg";
import rds from "../../../../assets/img/new/aws-rds.svg";
import Content from "../../../common/Content";
import Accordion from "../../../common/Accordion";
import ListItem from "../../../common/ListItem";
import ProjectLinkBox from "../../../common/ProjectLinkBox";
import ProjectLink from "../../../common/ProjectLink";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse } from "@fortawesome/free-solid-svg-icons";
import { faGithub } from "@fortawesome/free-brands-svg-icons";

const Box = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export default function MangozBox() {
  return (
    <Box>
      <Title>음악 스트리밍 사이트, MangoZ</Title>
      <Division>팀 프로젝트</Division>
      <SkillBox
        skill={[
          { logo: "Jquery", content: "제이쿼리(JQuery)", color: "0769AD" },
          {
            logo: "JavaScript",
            content: "자바스크립트(JavaScript)",
            color: "F7DF1E",
            division: true,
          },
          { logo: "nodedotjs", content: "Node.js", color: "339933" },
          { logo: "amazonec2", content: "AWS EC2", color: "FF9900", img: ec2 },
          { logo: "amazonrds", content: "AWS RDS", color: "527FFF", img: rds },
          {
            logo: "amazons3",
            content: "AWS S3",
            color: "569A31",
            division: true,
            img: s3,
          },
          { logo: "Mysql", content: "MySQL", color: "4479A1" },
        ]}
      />
      <Content>
        <Accordion title="개요" open={true}>
          MangoZ(망고즈) 는 음악 스트리밍, 실시간 채팅 기능을 제공하는 음악
          플랫폼입니다. 사용자는 음악을 재생하고, 플레이리스트를 만들고, 다른
          사용자와 관심있는 아티스트에 대해 실시간 채팅을 통해 소통할 수
          있습니다.
        </Accordion>
        <Accordion title="주요 기능 및 역할" open={true}>
          <ListItem>음악 스트리밍 기능을 제공합니다.</ListItem>
          <ListItem>
            플레이리스트를 생성하고 공유할 수 있으며, 드래그 앤 드롭으로 곡
            순서를 변경할 수 있습니다.
          </ListItem>
          <ListItem>
            제목, 아티스트, 앨범, 가사 검색 기능을 제공합니다.
          </ListItem>
          <ListItem>
            Socket.io를 활용하여 실시간 아티스트톡(A-Talk) 기능을 구현했습니다.
          </ListItem>
          <ListItem>JQuery를 사용해 SPA 구조화를 진행했습니다.</ListItem>
          <ListItem>AWS S3를 이용한 이미지 업로드 기능을 제공합니다.</ListItem>
          <ListItem>JWT 기반 인증을 통해 사용자 인증을 지원합니다.</ListItem>
        </Accordion>
      </Content>
      <ProjectLinkBox>
        {/* <ProjectLink href="https://poetic-druid-deac2a.netlify.app/" title="Home">
          <FontAwesomeIcon icon={faHouse} />
        </ProjectLink> */}
        <ProjectLink href="https://github.com/Leewonno/project2" title="Github">
          <FontAwesomeIcon icon={faGithub} />
        </ProjectLink>
      </ProjectLinkBox>
    </Box>
  );
}
